import styled from "styled-components";

interface IChartContainer {
  chartHeight?: number;
}

export const ChartContainer = styled("div")`
  height: ${(props: IChartContainer) =>
        props.chartHeight ? props.chartHeight : 360}px;
  width: 100%;
  padding: 26px 26px 26px 0px;
`;
